import { FlashMessageDto } from '../../../dto/flashmessage/get/flashmessagedto';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface DedicateFlashMessageResponse extends MiddlewareAPIResponse
{
    getFlashMessageResponseDto(): FlashMessageDto;
}

export class DedicateFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements DedicateFlashMessageResponse
{
    private getFlashMessageDto : FlashMessageDto;

    getFlashMessageResponseDto(): FlashMessageDto
    {
        return this.getFlashMessageDto;
    }

    setFlashMessageResponseDto(getFlashMessageDto: FlashMessageDto)
    {
        this.getFlashMessageDto = getFlashMessageDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/dedicate/dedicateflashmessagesresponse.tsx